
// 底层组件库
import barOption from './components/bar'
import datetimeOption from './components/datetime'
import flopOption from './components/flop'
import funnelOption from './components/funnel'
import gaugeOption from './components/gauge'
import iframeOption from './components/iframe'
import imgOption from './components/img'
import imgborderOption from './components/imgborder'
import lineOption from './components/line'
import mapOption from './components/map'
import pictorialbarOption from './components/pictorialbar'
import pieOption from './components/pie'
import progressOption from './components/progress'
import radarOption from './components/radar'
import scatterOption from './components/scatter'
import swiperOption from './components/swiper'
import tableOption from './components/table'
import tabsOption from './components/tabs'
import textOption from './components/text'
import videoOption from './components/video'
import commonOption from './components/common'
import wordcloudOption from './components/wordcloud'
//通用配置
import mainOption from './components/main'
//自定义组件库
import testOption from '@/components/test/option'
import StraightLineOption from '@/components/StraightLine/option'
import VerticalLineOption from '@/components/VerticalLine/option'
import RectangleOption from '@/components/Rectangle/option'
import RoundOption from '@/components/Round/option'
import navigationOption from '@/components/Navigation/option'
import fleetListOption from '@/components/FleetList/option'
import devicePropertyOption from '@/components/DeviceProperty/option'
import deviceGroupOption from '@/components/DeviceGroup/option'
import deviceStatusOption from '@/components/DeviceStatus/option'
import componentTitleOption from '@/components/ComponentTitle/option'
import weekScheduleOption from '@/components/WeekSchedule/option'
//3D地图
import DmapOption from '@/components/3Dmap/option'
//视频流播放器
import PlayerOption from '@/components/VideoPlayer/option'

export default {
  components: {
    commonOption,
    mainOption,
    barOption,
    datetimeOption,
    flopOption,
    funnelOption,
    gaugeOption,
    iframeOption,
    imgOption,
    imgborderOption,
    lineOption,
    mapOption,
    pictorialbarOption,
    pieOption,
    progressOption,
    radarOption,
    scatterOption,
    swiperOption,
    tableOption,
    tabsOption,
    textOption,
    videoOption,
    wordcloudOption,
    testOption,
    DmapOption,
    PlayerOption,
    StraightLineOption,
    VerticalLineOption,
    RectangleOption,
    RoundOption,
    navigationOption,
    productListOption: fleetListOption,
    deviceListOption: fleetListOption,
    devicePropertyOption,
    deviceGroupOption,
    deviceStatusOption,
    componentTitleOption,
    weekScheduleOption,
  }
}
